// from: https://github.com/jordihales/hypercolor/blob/master/assets/data/gradients.js
export const gradients = [
  {
    name: 'Hyper',
    direction: 'bg-gradient-to-r',
    colors: 'from-pink-500 via-red-500 to-yellow-500',
  },
  {
    name: 'Oceanic',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-300 via-blue-500 to-purple-600',
  },
  {
    name: 'Cotton Candy',
    direction: 'bg-gradient-to-r',
    colors: 'from-pink-300 via-purple-300 to-indigo-400',
  },
  {
    name: 'Gotham',
    direction: 'bg-gradient-to-r',
    colors: 'from-gray-700 via-gray-900 to-black',
  },
  {
    name: 'Sunset',
    direction: 'bg-gradient-to-r',
    colors: 'from-indigo-200 via-red-200 to-yellow-100',
  },
  {
    name: 'Mojave',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-100 via-yellow-300 to-yellow-500',
  },
  {
    name: 'Beachside',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 via-green-200 to-green-500',
  },
  {
    name: 'Gunmetal',
    direction: 'bg-gradient-to-r',
    colors: 'from-gray-200 via-gray-400 to-gray-600',
  },
  {
    name: 'Peachy',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-200 via-red-300 to-yellow-200',
  },
  {
    name: 'Seafoam',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-200 via-green-300 to-blue-500',
  },
  {
    name: 'Pumpkin',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 via-yellow-400 to-yellow-700',
  },
  {
    name: 'Pandora',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-200 via-green-400 to-purple-700',
  },
  {
    name: 'Valentine',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-200 to-red-600',
  },
  {
    name: 'Hawaii',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-300 via-yellow-300 to-pink-300',
  },
  {
    name: 'Lavender',
    direction: 'bg-gradient-to-r',
    colors: 'from-indigo-300 to-purple-400',
  },
  {
    name: 'Wintergreen',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-200 to-green-500',
  },
  {
    name: 'Huckleberry',
    direction: 'bg-gradient-to-r',
    colors: 'from-purple-200 via-purple-400 to-purple-800',
  },
  {
    name: 'Blue Steel',
    direction: 'bg-gradient-to-r',
    colors: 'from-gray-400 via-gray-600 to-blue-800',
  },
  {
    name: 'Arendelle',
    direction: 'bg-gradient-to-r',
    colors: 'from-blue-100 via-blue-300 to-blue-500',
  },
  {
    name: 'Spearmint',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-200 via-green-400 to-green-500',
  },
  {
    name: 'Minnesota',
    direction: 'bg-gradient-to-r',
    colors: 'from-purple-400 to-yellow-400',
  },
  {
    name: 'Bombpop',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-400 via-gray-300 to-blue-500',
  },
  {
    name: 'Acadia',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-800 via-yellow-600 to-yellow-500',
  },
  {
    name: 'Sonora',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 to-yellow-500',
  },
  {
    name: 'Paradise',
    direction: 'bg-gradient-to-r',
    colors: 'from-blue-300 via-green-200 to-yellow-300',
  },
  {
    name: 'Sierra Mist',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 via-green-200 to-green-300',
  },
  {
    name: 'Creamsicle',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 via-yellow-300 to-yellow-400',
  },
  {
    name: 'Midnight',
    direction: 'bg-gradient-to-r',
    colors: 'from-blue-700 via-blue-800 to-gray-900',
  },
  {
    name: 'Borealis',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-300 to-purple-400',
  },
  {
    name: 'Strawberry',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-200 via-pink-200 to-pink-400',
  },
  {
    name: 'Flamingo',
    direction: 'bg-gradient-to-r',
    colors: 'from-pink-400 to-pink-600',
  },
  {
    name: 'Burning Sunrise',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-600 to-red-600',
  },
  {
    name: 'Apple',
    direction: 'bg-gradient-to-r',
    colors: 'from-green-500 to-green-700',
  },
  {
    name: 'Watermelon',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-500 to-green-500',
  },
  {
    name: 'Flare',
    direction: 'bg-gradient-to-r',
    colors: 'from-orange-600 to-orange-500',
  },
  {
    name: 'Rasta',
    direction: 'bg-gradient-to-r',
    colors: 'from-lime-600 via-yellow-300 to-red-600',
  },
  {
    name: 'Lust',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-700 to-pink-600',
  },
  {
    name: 'Sublime',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-400 via-fuchsia-500 to-indigo-500',
  },
  {
    name: 'Witch',
    direction: 'bg-gradient-to-r',
    colors: 'from-slate-900 via-purple-900 to-slate-900',
  },
  {
    name: 'Powerpuff',
    direction: 'bg-gradient-to-r',
    colors: 'from-sky-400 via-rose-400 to-lime-400',
  },
  {
    name: 'Solid Blue',
    direction: 'bg-gradient-to-r',
    colors: 'from-blue-500 to-blue-600',
  },
  {
    name: 'Ice',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-100 to-teal-100',
  },
  {
    name: 'Sky',
    direction: 'bg-gradient-to-b',
    colors: 'from-sky-400 to-sky-200',
  },
  {
    name: 'Horizon',
    direction: 'bg-gradient-to-b',
    colors: 'from-orange-500 to-yellow-300',
  },
  {
    name: 'Morning',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-400 to-orange-300',
  },
  {
    name: 'Space',
    direction: 'bg-gradient-to-b',
    colors: 'from-gray-900 to-gray-600 bg-gradient-to-r',
  },
  {
    name: 'Earth',
    direction: 'bg-gradient-to-r',
    colors: 'from-teal-200 to-lime-200',
  },
  {
    name: 'Picture',
    direction: 'bg-gradient-to-r',
    colors: 'from-fuchsia-500 via-red-600 to-orange-400',
  },
  {
    name: 'Messenger',
    direction: 'bg-gradient-to-r',
    colors: 'from-sky-400 to-blue-500',
  },
  {
    name: 'Sea',
    direction: 'bg-gradient-to-r',
    colors: 'from-cyan-200 to-cyan-400',
  },
  {
    name: 'Payment',
    direction: 'bg-gradient-to-r',
    colors: 'from-sky-400 to-cyan-300',
  },
  {
    name: 'Video',
    direction: 'bg-gradient-to-r',
    colors: 'from-red-500 to-red-800',
  },
  {
    name: 'Passion',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-500 via-red-400 to-red-500',
  },
  {
    name: 'Flower',
    direction: 'bg-gradient-to-r',
    colors: 'from-violet-300 to-violet-400',
  },
  {
    name: 'Cool Sunset',
    direction: 'bg-gradient-to-r',
    colors: 'from-orange-300 to-rose-300',
  },
  {
    name: 'Pink Neon',
    direction: 'bg-gradient-to-r',
    colors: 'from-fuchsia-600 to-pink-600',
  },
  {
    name: 'Blue Sand',
    direction: 'bg-gradient-to-r',
    colors: 'from-slate-500 to-yellow-100',
  },
  {
    name: 'Emerald',
    direction: 'bg-gradient-to-r',
    colors: 'from-emerald-500 to-lime-600',
  },
  {
    name: 'Relaxed Rose',
    direction: 'bg-gradient-to-r',
    colors: 'from-rose-300 to-rose-500',
  },
  {
    name: 'Purple Haze',
    direction: 'bg-gradient-to-r',
    colors: 'from-purple-800 via-violet-900 to-purple-800',
  },
  {
    name: 'Silver',
    direction: 'bg-gradient-to-r',
    colors: 'from-gray-100 to-gray-300',
  },
  {
    name: 'Orange Coral',
    direction: 'bg-gradient-to-r',
    colors: 'from-orange-400 to-rose-400',
  },
  {
    name: 'Blue Coral',
    direction: 'bg-gradient-to-r',
    colors: 'from-blue-400 to-emerald-400',
  },
  {
    name: 'Beam of Light',
    direction: 'bg-conic-to-t',
    colors: 'from-gray-900 via-gray-100 to-gray-900',
    version: 'Conic',
  },
  {
    name: 'Safari Sunset',
    direction: 'bg-conic-to-l',
    colors: 'from-yellow-500 via-purple-500 to-blue-500',
    version: 'Conic',
  },
  {
    name: 'High Tide',
    direction: 'bg-conic-to-tl',
    colors: 'from-sky-500 via-orange-200 to-yellow-600',
    version: 'Conic',
  },
  {
    name: 'Hunniepop',
    direction: 'bg-conic-to-bl',
    colors: 'from-fuchsia-300 via-green-400 to-rose-700',
    version: 'Conic',
  },
  {
    name: 'Soft Metal',
    direction: 'bg-conic-to-r',
    colors: 'from-indigo-200 via-slate-600 to-indigo-200',
    version: 'Conic',
  },
  {
    name: 'Coral Sun',
    direction: 'bg-conic-to-tl',
    colors: 'from-yellow-200 via-emerald-200 to-yellow-200',
    version: 'Conic',
  },
  {
    name: 'Power Pink',
    direction: 'bg-conic-to-l',
    colors: 'from-rose-500 to-indigo-700',
    version: 'Conic',
  },
  {
    name: 'Powder Blue',
    direction: 'bg-conic-to-l',
    colors: 'from-sky-400 to-blue-800',
    version: 'Conic',
  },
  {
    name: 'Moody Sunset',
    direction: 'bg-conic-to-l',
    colors: 'from-rose-900 via-amber-800 to-rose-400',
    version: 'Conic',
  },
  {
    name: 'Burnt Sand',
    direction: 'bg-conic-to-l',
    colors: 'from-yellow-200 via-red-500 to-fuchsia-500',
    version: 'Conic',
  },
  {
    name: 'Blue / White Split',
    direction: 'bg-conic-to-b',
    colors: 'from-white via-sky-500 to-sky-500',
    version: 'Conic',
  },
  {
    name: 'Purple Beam',
    direction: 'bg-gradient-to-bl',
    colors: 'from-indigo-900 via-indigo-400 to-indigo-900',
  },
  {
    name: 'Sand Beam',
    direction: 'bg-conic-to-t',
    colors: 'from-orange-900 via-amber-100 to-orange-900',
    version: 'Conic',
  },
  {
    name: 'Island Waves',
    direction: 'bg-gradient-to-r',
    colors: 'from-yellow-400 via-gray-50 to-teal-300',
  },
  {
    name: 'Big Sur',
    direction: 'Pastel',
    colors: 'bg-gradient-to-tr from-violet-500 to-orange-300',
  },
  {
    name: 'Oahu',
    direction: 'bg-gradient-to-t',
    colors: 'from-orange-400 to-sky-400',
  },
  {
    name: 'Peach Pie',
    direction: 'bg-conic-to-r',
    colors: 'from-red-900 via-violet-200 to-orange-500',
    version: 'Conic',
  },
  {
    name: 'Salem',
    direction: 'bg-gradient-to-b',
    colors: 'from-gray-900 via-purple-900 to-violet-600',
  },
  {
    name: 'Purple Burst',
    direction: 'bg-radial',
    colors: 'from-purple-900 to-indigo-500',
    version: 'Radial',
  },
  {
    name: 'Amber Sunrise',
    direction: 'bg-radial-at-b',
    colors: 'from-amber-900 to-yellow-300',
    version: 'Radial',
  },
  {
    name: 'Sky Sea',
    direction: 'bg-radial-at-r',
    colors: 'from-sky-400 to-indigo-900',
    version: 'Radial',
  },
  {
    name: 'Rocket Power',
    direction: 'bg-radial-at-t',
    colors: 'from-amber-700 via-orange-300 to-rose-800',
    version: 'Radial',
  },
  {
    name: 'Blue Flame',
    direction: 'bg-radial-at-b',
    colors: 'from-amber-200 via-violet-600 to-sky-900',
    version: 'Radial',
  },
  {
    name: 'Warm Glow',
    direction: 'bg-radial-at-t',
    colors: 'from-gray-300 via-fuchsia-600 to-orange-600',
    version: 'Radial',
  },
];
